import React from "react";

/**
 * Oran hücresini bülten turunda DEĞİŞTİYSE kısa süre yanıp söndürür (4nala ile aynı
 * davranış): yükseldiyse yeşil, düştüyse kırmızı. Yönü `bulletin.service`teki
 * `mergeOdds` üretiyor (`isUpdated`).
 *
 * `key` şart: sınıf ("up") art arda gelen AYNI yönlü değişimlerde aynı kaldığı için
 * CSS animasyonu tek başına yeniden başlamıyor. `oddsRevision` her gerçek değişimde
 * artıyor, düğüm yeniden kuruluyor ve animasyon baştan çalışıyor.
 *
 * Animasyon 4 turda kendini bitiriyor; sınıfı kaldıracak bir bülten turu beklenmiyor.
 */
export function OddsFlash({entry, children}: { entry: any; children: React.ReactNode }) {
    return (
        <span key={entry?.oddsRevision ?? 0} className={`odds-flash ${entry?.isUpdated ?? ""}`}>
            {children}
        </span>
    );
}
